import { render } from "./RiskAnalysisPieCharts.vue?vue&type=template&id=20a73bf7&scoped=true"
import script from "./RiskAnalysisPieCharts.vue?vue&type=script&lang=js"
export * from "./RiskAnalysisPieCharts.vue?vue&type=script&lang=js"

import "./RiskAnalysisPieCharts.vue?vue&type=style&index=0&id=20a73bf7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a73bf7"]])

export default __exports__